<template>
  <div
    id="tableContainer"
    ref="tableContainer"
    class="vs-component vs-con-table vs-con-loading__container"
    :style="[
      bodyHeight ? `height: ${bodyHeight}; max-height: ${bodyHeight}; min-height: ${bodyHeight};`: '',
      isFlexibleHeight ? 'min-height: auto;': ''].join(' ')"
  >
    <div
      class="con-tablex vs-table--content"
      :class="{'rotate-scrollbar': isScrollTop && !loading}"
    >
      <!-- Add top scrollbar container -->
      <div
        class="top-scroll-container"
        @scroll="handleTopScroll"
      >
        <div
          class="top-scroll-content"
          :style="{ width: tableWidth + 'px' }"
        />
      </div>

      <div
        v-if="!isEmpty(tableData)"
        class="vs-con-tbody vs-table--tbody"
        :class="{'rotate-scrollbar': isScrollTop && !loading}"
        ref="tableBody"
        @scroll="handleTableScroll"
      >
        <table class="vs-table vs-table--tbody-table h-full relative">
          <tbody>
            <tr class="align-baseline">
              <!-- Frozen columns container -->
              <td
                class="frozen-container"
                v-if="frozenColumns > 0"
              >
                <!-- Custom resizable column -->
                <div
                  class="resizable h-full"
                  ref="resizable"
                  :key="dataTableKey"
                  @mousemove="onMouseMove"
                  @mouseup="onMouseUp"
                >
                  <table
                    :style="tableStyle"
                  >
                    <thead class="vs-table--thead">
                      <template v-if="groupedHeaders && groupedHeaders.length">
                        <tr>
                          <th
                            v-for="(th, indexth) in frozenColumnsData"
                            :key="'group-frozen-' + indexth"
                            class="th vs-table--th frozen"
                            :style="[
                              headerHeight ? `height:${headerHeight}; max-height:${headerHeight};` : '',
                              th.width ? `width: ${th.width}; min-width: ${th.width}` : ''
                            ].join(' ')"
                          />
                        </tr>
                      </template>
                      <tr>
                        <th
                          v-for="(th, indexth) in frozenColumnsData"
                          :key="indexth"
                          :class="`th vs-table--th frozen ${th.sortable && 'cursor-pointer'}`"
                          :style="[
                            headerHeight ? `height:${headerHeight}; max-height:${headerHeight};` : '',
                            th.width ? `width: ${th.width}; min-width: ${th.width}` : ''
                          ].join(' ')"
                        >
                          <div
                            @click="sort(th)"
                            class="th-wrapper"
                          >
                            <span
                              v-if="th.sortable"
                              class="sort"
                            >
                              <img
                                :sort-by="((sortBy === th.sortKey || sortBy === th.key) && sortDir === 'asc')"
                                class="up"
                                :src="require('@/assets/shipo-sales-plan-arrow-up.svg')"
                              >
                              <img
                                :sort-by="((sortBy === th.sortKey || sortBy === th.key) && sortDir === 'desc')"
                                class="down"
                                :src="require('@/assets/shipo-sales-plan-arrow-down.svg')"
                              >
                            </span>
                            <vs-checkbox
                              v-if="th.key === keyHeaderCheckbox"
                              color="primary"
                              v-model="isAllSelected"
                              @input="val => $emit('checkAll', val)"
                              :disabled="isHeaderCheckboxDisabled"
                            />
                            <span
                              v-else
                              class="whitespace-no-wrap"
                            >
                              {{ th.label }}
                            </span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(tr, indextr) in data">
                        <tr
                          :key="indextr"
                          :class="['tr-values hoverFlat vs-table--tr frozen', hoveredRow === indextr ? 'is-hovered': '', rowClass(tr)].join(' ')"
                          :style="rowStyle"
                          @mouseenter="hoveredRow = indextr"
                          @mouseleave="hoveredRow = null"
                        >
                          <td
                            v-for="(td, indextd) in frozenColumnsData"
                            :key="indextd"
                            :class="`td vs-table--td frozen pt-0 pb-0`"
                            :style="[
                              `height:${rowHeight}; max-height:${rowHeight}`,
                              td.width ? `width: ${td.width}; min-width: ${td.width}` : '',
                              columnStyle
                            ].join(' ')"
                          >
                            <div
                              :style="{
                                overflow: 'visible',
                                display: 'flex',
                                alignItems: 'center',
                                height: rowHeight,
                                maxHeight: rowHeight,
                              }"
                            >
                              <div
                                :style="{
                                  maxHeight: '100%',
                                  overflow: 'visible',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }"
                              >
                                <slot
                                  v-if="!isTdStatic"
                                  :name="td.key"
                                  class="max-h-full overflow-y-auto"
                                  :row="tr"
                                  :index="indextr"
                                >
                                  {{ tr[td.key] }}
                                </slot>
                                <slot
                                  v-else
                                  name="td"
                                  :header="td.key"
                                  class="max-h-full overflow-y-auto"
                                  :row="tr"
                                  :index="indextr"
                                >
                                  {{ tr[td.key] }}
                                </slot>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <template
                          v-if="!tr.isEditing && expandedRows.includes(tr.expandedRef ? tr.expandedRef : tr.id)"
                        >
                          <template v-if="isExpandedRowKeepSameHeaderCol">
                            <slot
                              name="detail-frozen"
                              class="max-h-full overflow-y-auto"
                              :parent-data="tr"
                              :parent-index="indextr"
                            >
                              {{ tr }}
                            </slot>
                          </template>
                          <template v-else>
                            <tr
                              v-if="!tr.isEditing && expandedRows.includes(tr.expandedRef ? tr.expandedRef : tr.id)"
                              :key="'details-frozen' + indextr"
                            >
                              <td
                                :colspan="frozenColumnsData.length"
                                class="bg-gray-50 p-4 text-gray-700"
                              >
                                <slot
                                  name="detail-frozen"
                                  class="max-h-full overflow-y-auto"
                                  :parent-data="tr"
                                  :parent-index="indextr"
                                >
                                  {{ tr }}
                                </slot>
                              </td>
                            </tr>
                          </template>
                        </template>
                      </template>
                    </tbody>
                  </table>
                  <div
                    class="resizer"
                    @mousedown="onMouseDown"
                  />
                </div>
              </td>

              <!-- Scrollable columns container -->
              <td class="scrollable-container">
                <table
                  class="w-full"
                  :style="tableStyle"
                >
                  <thead
                    v-if="!isHideHeader"
                    class="vs-table--thead"
                  >
                    <template v-if="groupedHeaders && groupedHeaders.length">
                      <tr>
                        <template v-for="(group, groupIndex) in groupedHeadersData">
                          <th
                            v-if="group.title"
                            :key="'group-' + groupIndex"
                            class="th vs-table--th group-header"
                            :style="{
                              backgroundColor: group.backgroundColor,
                              width: group.width,
                              minWidth: group.width
                            }"
                            :colspan="group.colspan"
                          >
                            {{ group.title }}
                          </th>
                          <th
                            v-else
                            :key="'empty-' + groupIndex"
                            class="th vs-table--th"
                            :style="{
                              width: group.width,
                              minWidth: group.width
                            }"
                            :colspan="group.colspan"
                          />
                        </template>
                      </tr>
                    </template>
                    <tr>
                      <th
                        v-for="(th, indexth) in scrollableColumnsData"
                        :key="indexth"
                        :class="`th vs-table--th ${th.sortable && 'cursor-pointer'}`"
                        :style="[
                          headerHeight ? `height:${headerHeight}; max-height:${headerHeight};`: '',
                          th.width ? `width: ${th.width}; min-width: ${th.width}` : ''
                        ].join(' ')"
                      >
                        <div
                          @click="sort(th)"
                          class="th-wrapper"
                        >
                          <span
                            v-if="th.sortable"
                            class="sort"
                          >
                            <img
                              :sort-by="((sortBy === th.sortKey || sortBy === th.key) && sortDir === 'asc')"
                              class="up"
                              :src="require('@/assets/shipo-sales-plan-arrow-up.svg')"
                            >
                            <img
                              :sort-by="((sortBy === th.sortKey || sortBy === th.key) && sortDir === 'desc')"
                              class="down"
                              :src="require('@/assets/shipo-sales-plan-arrow-down.svg')"
                            >
                          </span>
                          <vs-checkbox
                            v-if="th.key === keyHeaderCheckbox"
                            color="primary"
                            v-model="isAllSelected"
                            @input="val => $emit('checkAll', val)"
                            :disabled="isHeaderCheckboxDisabled"
                          />
                          <span
                            v-else
                            class="whitespace-no-wrap"
                            v-html="th.label"
                          />
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(tr, indextr) in data">
                      <tr
                        :key="indextr"
                        :class="['tr-values hoverFlat vs-table--tr', hoveredRow === indextr ? 'is-hovered': '', rowClass(tr), tr.hasOwnProperty('isGroupStart') ? tr.isGroupStart ? 'group-start' : 'group-row' : ''].join(' ') "
                        :style="rowStyle"
                        @mouseenter="hoveredRow = indextr"
                        @mouseleave="hoveredRow = null"
                        :draggable="rowDraggable"
                        @dragstart="onRowDragStart($event, tr)"
                      >
                        <td
                          v-for="(td, indextd) in scrollableColumnsData"
                          :key="indextd"
                          :class="`td vs-table--td ${frozenColumns > 1 ? 'rounded-l-none' : ''}  pt-0 pb-0`"
                          :style="[
                            `height:${rowHeight}; max-height:${rowHeight};`,
                            td.width ? `width: ${td.width}; min-width: ${td.width};` : '',
                            columnStyle
                          ].join(' ')"
                        >
                          <div
                            :style="{
                              overflow: 'visible',
                              display: 'flex',
                              alignItems: 'center',
                              height: rowHeight,
                              maxHeight: rowHeight,
                            }"
                          >
                            <div
                              :style="{
                                flex: 1, // Allows content to shrink inside the td
                                maxHeight: '100%',
                                overflow: 'visible',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }"
                            >
                              <slot
                                v-if="!isTdStatic"
                                :name="td.key"
                                :row="tr"
                                class="max-h-full overflow-y-auto"
                                :index="indextr"
                              >
                                {{ tr[td.key] }}
                              </slot>
                              <slot
                                v-else
                                name="td"
                                :header="td.key"
                                class="max-h-full overflow-y-auto"
                                :row="tr"
                                :index="indextr"
                              >
                                {{ tr[td.key] }}
                              </slot>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <template
                        v-if="!tr.isEditing && expandedRows.includes(tr.expandedRef ? tr.expandedRef : tr.id)"
                      >
                        <template v-if="isExpandedRowKeepSameHeaderCol">
                          <slot
                            name="detail"
                            class="max-h-full overflow-y-auto"
                            :parent-data="tr"
                            :parent-index="indextr"
                          >
                            {{ tr }}
                          </slot>
                        </template>
                        <template v-else>
                          <tr
                            v-if="!tr.isEditing && expandedRows.includes(tr.expandedRef ? tr.expandedRef : tr.id)"
                            :key="'details-' + indextr"
                          >
                            <td
                              :colspan="scrollableColumnsData.length"
                              class="bg-gray-50 p-4 text-gray-700"
                            >
                              <slot
                                name="detail"
                                class="max-h-full overflow-y-auto"
                                :parent-data="tr"
                                :parent-index="indextr"
                              >
                                {{ tr }}
                              </slot>
                            </td>
                          </tr>
                        </template>
                      </template>
                    </template>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <no-data
        v-show="isEmpty(tableData)"
        title="No Data Found"
        message="No item matching your search."
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import NoData from '@/components/noData'

export default {
  name: 'DataTable',
  components: {
    NoData
  },
  props: {
    isTdStatic: {
      type: Boolean,
      default: () => false
    },
    isScrollTop: {
      type: Boolean,
      default: () => false
    },
    tableHeader: {
      type: Array,
      default: () => []
    },
    tableData: {
      type: Array,
      default: () => []
    },
    sortBy: {
      type: String,
      default: null
    },
    sortDir: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    hoverFlat: {
      type: Boolean,
      default: false
    },
    frozenColumns: {
      type: Number,
      default: 0
    },
    headerHeight: {
      type: String,
      default: '3.2rem'
    },
    rowHeight: {
      type: String,
      default: '4rem'
    },
    expandedRowsList: {
      type: Array,
      default: () => []
    },
    groupedHeaders: {
      type: Array,
      default: () => []
    },
    bodyHeight: {
      type: String,
      default: null
    },
    isExpandedRowKeepSameHeaderCol: {
      type: Boolean,
      default: false
    },
    rowStyle: {
      type: String,
      default: null
    },
    rowClass: {
      type: Function,
      default: () => () => ({})
    },
    columnStyle: {
      type: String,
      default: null
    },
    tableStyle: {
      type: String,
      default: null
    },
    rowDraggable: {
      type: Boolean,
      default: false
    },
    isFlexibleHeight: {
      type: Boolean,
      default: false
    },
    keyHeaderCheckbox: {
      type: String,
      default: null
    },
    isHeaderCheckboxDisabled: {
      type: Boolean,
      default: false
    },
    isHideHeader: {
      type: Boolean,
      default: false
    },
    headerCheckboxDefaultChecked: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    headerCheckboxDefaultChecked: {
      handler(val) {
        this.isAllSelected = val
      },
      immediate: true
    },
    tableData: {
      handler: function(val, oldVal) {
        if(val) {
          this.$nextTick(() => {
            this.updateTableWidth()
            // Add resize observer to update width when table size changes
            const resizeObserver = new ResizeObserver(() => {
              this.updateTableWidth()
            })
            const table = this.$el.querySelector('.vs-table--tbody-table')
            if (table) {
              resizeObserver.observe(table)
            }
          })
        }
        this.data = val
        this.columnsToBeChangeWidth = []
        this.columnsFirstDivWidth = []

        if (val.length !== oldVal.length) {
          this.dataTableKey += 1 // <--- This will force rerender
        }
      },
      deep: true
    },
    data: {
      handler(val) {
        if (Array.isArray(val) && val.some(row => row && row.isEditing)) {
          this.$nextTick(() => this.revertResize())
        }
      },
      deep: true
    },
    loading: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.$vs.loading({
              type: 'radius',
              color: 'secondary',
              container: this.$refs.tableContainer,
              scale: 0.5
            })
          })
          return
        }
        this.$nextTick(() => {
          this.$vs.loading.close(this.$refs.tableContainer)
        })
      }
    },
    expandedRowsList: {
      immediate: true,
      handler(val) {
        if (val) {
          this.expandedRows = val
        }
      }
    }
  },
  data() {
    return {
      data: this.tableData,
      hoveredRow: null,
      expandedRows: [],
      tableWidth: 0,
      isScrolling: false,
      isResizing: false,
      startX: 0,
      startWidth: 0,
      columnsToBeChangeWidth: [],
      columnsFirstDivWidth: [],
      originalColumnWidths: null,
      originalFirstDivWidths: null,
      originalResizableWidth: null,
      dataTableKey: 0,
      isAllSelected: false
    }
  },
  methods: {
    sort(column) {
      const sortDir = !this.sortDir
        ? 'asc'
        : this.sortDir === 'asc'
          ? 'desc'
          : ''
      const sortBy = sortDir
        ? column.sortKey || column.key
        : ''
      if (column.sortable) {
        this.$emit('sort', sortBy, sortDir)
      }
    },
    refresh() {
      this.$forceUpdate()
    },
    calculateWidth(columns) {
      return `${columns.reduce((total, col) => {
        const colWidth = parseInt(col.width) || 120 // Default width if not specified
        return total + colWidth
      }, 0)}px`
    },
    onRowDragStart(event, row) {
      event.dataTransfer.setData('rowData', JSON.stringify(row))
    },
    handleTableScroll(e) {
      // Sync the top scrollbar with the table's horizontal scroll
      const topScroll = this.$el.querySelector('.top-scroll-container')
      if (topScroll && !this.isScrolling) {
        this.isScrolling = true
        topScroll.scrollLeft = e.target.scrollLeft
        this.isScrolling = false
      }
    },
    handleTopScroll(e) {
      // Sync the table with the top scrollbar's horizontal scroll
      if (!this.isScrolling) {
        this.isScrolling = true
        this.$refs.tableBody.scrollLeft = e.target.scrollLeft
        this.isScrolling = false
      }
    },
    revertResize() {
      const resizable = this.$refs.resizable
      if (!resizable) return
      const table = resizable.querySelector('table')
      if (!table) return

      // Reset container width to auto so table dictates width
      resizable.style.width = ''
      table.style.minWidth = ''

      const ths = table.querySelectorAll('th')
      const tds = table.querySelectorAll('td')

      // Clear inline styles applied during resize on headers
      ths.forEach(th => {
        th.style.width = ''
        th.style.minWidth = ''
        const firstDiv = th.querySelector('div')
        if (firstDiv) {
          firstDiv.style.width = ''
          firstDiv.style.minWidth = ''
          if (firstDiv.style.overflow === 'hidden') firstDiv.style.overflow = 'visible'
          // Clear any nested inline overflow set to hidden
          firstDiv.querySelectorAll('*').forEach(el => {
            if (el.style && el.style.overflow === 'hidden') el.style.overflow = 'visible'
          })
        }
      })

      // Clear inline styles applied during resize on cells
      tds.forEach(td => {
        td.style.width = ''
        td.style.minWidth = ''
        const firstDiv = td.querySelector('div')
        if (firstDiv) {
          firstDiv.style.width = ''
          firstDiv.style.minWidth = ''
          if (firstDiv.style.overflow === 'hidden') firstDiv.style.overflow = 'visible'
          const textDiv = firstDiv.querySelector('span')
          if (textDiv && textDiv.closest('div') && textDiv.closest('div').style.overflow === 'hidden') {
            textDiv.closest('div').style.overflow = 'visible'
          } else {
            const children = Array.from(firstDiv.children).reverse()
            for (const child of children) {
              if (child.textContent && child.textContent.trim() && child.children.length === 0) {
                if (child.style.overflow === 'hidden') child.style.overflow = 'visible'
              } else if (child.children.length > 0) {
                if (child.style.overflow === 'hidden') child.style.overflow = 'visible'
                for (const child2 of child.children) {
                  if (child2.textContent && child2.textContent.trim() && child2.children.length === 0) {
                    if (child2.style.overflow === 'hidden') child2.style.overflow = 'visible'
                  }
                }
              }
            }
          }
        }
      })

      // After clearing, set container width to match current table width
      resizable.style.width = `${table.offsetWidth}px`
    },
    updateTableWidth() {
      // Calculate total width of the table
      const table = this.$el.querySelector('.vs-table--tbody-table')
      if (table) {
        this.tableWidth = table.offsetWidth
      }
    },
    onMouseDown(e) {
      this.isResizing = true
      this.startX = e.clientX
      this.startWidth = this.$refs.resizable.offsetWidth
      const table = this.$refs.resizable.querySelector('table')
      // Store the original widths only once
      if (!this.originalColumnWidths || !this.originalFirstDivWidths || Array.from(table.querySelectorAll('td')).length !== this.originalFirstDivWidths.length) {
        this.originalColumnWidths = table ? Array.from(table.querySelectorAll('th, td')).map(col => col.offsetWidth) : []
        this.originalFirstDivWidths = table ? Array.from(table.querySelectorAll('td')).map(td => {
          const firstDiv = td.querySelector('div')
          return firstDiv ? firstDiv.offsetWidth : 0
        }) : []
      }
      // Store the original resizable width only once
      if (!this.originalResizableWidth) {
        this.originalResizableWidth = this.$refs.resizable.offsetWidth
      }
      // Always use the original widths as the base for resizing
      this.columnsToBeChangeWidth = this.originalColumnWidths ? [...this.originalColumnWidths] : []
      this.columnsFirstDivWidth = this.originalFirstDivWidths ? [...this.originalFirstDivWidths] : []
      document.body.style.cursor = 'ew-resize'

      // Listen on document to allow dragging outside the div
      document.addEventListener('mousemove', this.onMouseMove)
      document.addEventListener('mouseup', this.onMouseUp)
    },
    onMouseMove(e) {
      if (!this.isResizing) return
      const delta = e.clientX - this.startX
      const newWidth = Math.max(this.startWidth + delta, 50) // allow very small width
      this.$refs.resizable.style.width = `${newWidth}px`

      const table = this.$refs.resizable.querySelector('table')
      if (table) {
        table.style.minWidth = '0'
        // Always use the original resizable width for ratio
        const ratio = newWidth / this.originalResizableWidth
        // Resize all th and td
        const ths = table.querySelectorAll('th')
        const tds = table.querySelectorAll('td')
        ths.forEach((th, i) => {
          const startWidth = this.originalColumnWidths ? this.originalColumnWidths[i] : th.offsetWidth
          const minWidth = startWidth * 0.2
          th.style.width = `${Math.max(startWidth * ratio, minWidth)}px`
          th.style.minWidth = '0'
          // Also resize the first div inside th (if any)
          const firstDiv = th.querySelector('div')
          if (firstDiv) {
            const divStartWidth = this.originalFirstDivWidths ? this.originalFirstDivWidths[i] : firstDiv.offsetWidth
            const divMinWidth = divStartWidth * 0.2
            firstDiv.style.width = `${Math.max(divStartWidth * ratio, divMinWidth)}px`
            firstDiv.style.minWidth = '0'
            firstDiv.style.overflow = 'hidden'
          }
        })
        tds.forEach((td, i) => {
          const startWidth = this.originalColumnWidths ? this.originalColumnWidths[ths.length + i] : td.offsetWidth
          const minWidth = startWidth * 0.2
          td.style.width = `${Math.max(startWidth * ratio, minWidth)}px`
          td.style.minWidth = '0'
          // Also resize the first div inside td
          const firstDiv = td.querySelector('div')
          if (firstDiv) {
            const divStartWidth = this.originalFirstDivWidths ? this.originalFirstDivWidths[i] : firstDiv.offsetWidth
            const divMinWidth = divStartWidth * 0.2
            firstDiv.style.width = `${Math.max(divStartWidth * ratio, divMinWidth)}px`
            firstDiv.style.minWidth = '0'
            const textDiv = firstDiv.querySelector('span')
            if (textDiv) {
              textDiv.closest('div').style.overflow = 'hidden'
            } else {
              const children = Array.from(firstDiv.children).reverse()
              for (const child of children) {
                if (child.textContent.trim() && child.children.length === 0) {
                  child.style.overflow = 'hidden'
                } else {
                  child.style.overflow = 'visible'
                  if (child.children.length > 0) {
                    for (const child2 of child.children) {
                      if (child2.textContent.trim() && child2.children.length === 0) {
                        child2.style.overflow = 'hidden'
                      }
                    }
                  }
                }
              }
            }
          }
        })
        this.$refs.resizable.style.width = `${table.offsetWidth}px`
      }
    },
    onMouseUp() {
      if (this.isResizing) {
        this.isResizing = false
        document.body.style.cursor = 'default'
        document.removeEventListener('mousemove', this.onMouseMove)
        document.removeEventListener('mouseup', this.onMouseUp)
      }
    }
  },
  computed: {
    frozenColumnsData() {
      return this.tableHeader.slice(0, this.frozenColumns)
    },
    scrollableColumnsData() {
      return this.tableHeader.slice(this.frozenColumns)
    },
    groupedHeadersData() {
      if (!this.groupedHeaders || !this.groupedHeaders.length) return []

      const result = []
      let currentPosition = 0

      this.groupedHeaders.forEach(group => {
        const startIndex = this.scrollableColumnsData.findIndex(col => col.key === group.startColumn)
        const endIndex = this.scrollableColumnsData.findIndex(col => col.key === group.endColumn)

        if (startIndex === -1 || endIndex === -1) return

        // Add ungrouped columns before this group if any
        if (currentPosition < startIndex) {
          result.push({
            colspan: startIndex - currentPosition,
            width: this.calculateWidth(this.scrollableColumnsData.slice(currentPosition, startIndex))
          })
        }

        // Add the group
        result.push({
          ...group,
          colspan: endIndex - startIndex + 1,
          width: this.calculateWidth(this.scrollableColumnsData.slice(startIndex, endIndex + 1))
        })

        currentPosition = endIndex + 1
      })

      // Add any remaining ungrouped columns
      if (currentPosition < this.scrollableColumnsData.length) {
        result.push({
          colspan: this.scrollableColumnsData.length - currentPosition,
          width: this.calculateWidth(this.scrollableColumnsData.slice(currentPosition))
        })
      }

      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.vs-con-table {
  @apply bg-grey-005 px-4;
  height: 100%;
  min-height: 70vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .con-tablex {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .vs-table--tbody {
    flex: 1;
    background-color: #F8F8F8;
    overflow-y: auto;
    overflow-x: auto;
  }

  /deep/ .vs-table {
    @apply border-separate;
    border-spacing: 0 0.4rem;
    width: 100%;

    &--thead {
      position: sticky;
      top: 0;
      z-index: 4;
      background: #F8F8F8;

      tr {
        @apply bg-transparent #{!important};

        .th {
          @apply p-4;
          @apply pb-4;
          @apply text-grey;
          @apply font-semibold;
          height: 3.2rem;
          white-space: nowrap;
          font-size: 10pt;

          &:first-child {
            @apply pl-10;
          }

          &:last-child {
            @apply pr-10;
          }

          &.frozen {
            position: sticky;
            background: #F8F8F8;
            z-index: 2;

            &:first-child {
              left: 0;
            }
          }

          @for $i from 1 through 10 {
            &.frozen-#{$i} {
              left: calc(#{($i - 1) * 120}px);
            }
          }

          .sort-th {
            @apply hidden;
          }

          .cursor-def {
            @apply cursor-text #{!important};
          }

          .th-wrapper {
            @apply flex;
            @apply flex-wrap;
            @apply flex-grow;
            @apply flex-row;
            @apply items-center;

            .sort {
              @apply flex;
              @apply flex-wrap;
              @apply flex-col;
              @apply mr-1;
              @apply justify-center;
              margin-left: calc(-0.25rem - 10px);
              margin-top: -2px;

              .up {
                margin-bottom: -1.3px;

                &[sort-by="true"] {
                  opacity: 0;
                }
              }

              .down {
                margin-top: -1.3px;

                &[sort-by="true"] {
                  opacity: 0;
                }
              }
            }
          }

          &.group-header {
            @apply text-center;
            @apply font-semibold;
            border: 1px solid #E2E8F0;
            padding: 8px;
            height: auto;
            background-color: #E8F5E9;
          }
        }
      }
    }

    &--tr {

      .td {
        @apply pr-10;
        white-space: nowrap;
        box-sizing: border-box;
        overflow: visible;
        font-size: 10pt;
        padding-right: 10px !important;

        border-top: 1px solid transparent;
        border-bottom: 1px solid transparent;

        &:first-child {
          @apply pl-10;
          @apply rounded-l-2xl;
        }

        &:last-child {
          @apply pr-10;
          @apply rounded-r-2xl;
        }

        &.frozen {
          position: static;
          background: white;
          z-index: 3;


          &:first-child {
            left: 0;
          }

          &:last-child {
            border-top-right-radius: 0rem;
            border-bottom-right-radius: 0rem;
          }
        }

        &.notfrozen :first-child {

        }

        @for $i from 1 through 10 {
          &.frozen-#{$i} {
            left: calc(#{($i - 1) * 120}px);
          }
        }
      }
    }
  }

  ::-webkit-scrollbar {
    height: calc(6px + 1rem);
    width: calc(6px + 1rem);
  }

  ::-webkit-scrollbar-track {
    @apply bg-transparent;
  }

  ::-webkit-scrollbar-thumb {
    @apply rounded-full;
    border: 0.5rem solid #F1F1FD !important;
    background: #DEDEDE;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: mix(#000, #DEDEDE, 5%);
  }


  .scrollable-header-container {
    width: 100%;
    overflow-x: auto;
    position: relative;

    table {
      width: 100%;
      border-collapse: separate;
      table-layout: fixed;
    }
  }

  .frozen-container, .scrollable-container {
    width: auto;
    padding: 0;
    margin: 0;
    vertical-align: top;

    table {
      width: 100%;
      border-collapse: separate;
      table-layout: auto;
      border-spacing: 0 0.4rem;

      background: #F8F8F8;
    }
  }

  .frozen-container {
    position: sticky;
    left: 0;
    z-index: 3;
    background: #F8F8F8;
    border-right: 1px solid #e0e0e0;
  }

  .scrollable-container {
    position: sticky;
    z-index: 2;
    background: #F8F8F8;
  }

  .td.frozen, .th.frozen {
    background: white;
    z-index: 1;
    position: static; // Remove individual sticky positioning
  }
}

.rotate-scrollbar {
  transform: rotateX(180deg);
}

// change `opacity` in `hoverFlat` built-in class
.vs-table--tbody-table {
  .tr-values.hoverFlat:not(.activeEdit):not(.is-expand):hover {
    opacity: 1;
  }
}

.vs-table--tr[draggable="true"] {
  cursor: grab;
}

.vs-table--tr[draggable="true"]:active {
  cursor: grabbing;
}

.top-scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: -17px;
  position: relative;
  z-index: 1;

  &::-webkit-scrollbar {
    height: calc(6px + 1rem);
  }

  &::-webkit-scrollbar-track {
    @apply bg-transparent;
  }

  &::-webkit-scrollbar-thumb {
    @apply rounded-full;
    border: 0.5rem solid #F1F1FD !important;
    background: #DEDEDE;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: mix(#000, #DEDEDE, 5%);
  }
}

.top-scroll-content {
  height: 1px;
}

.vs-table--tbody {
  margin-top: 17px; // Compensate for the negative margin of top scrollbar
}

.resizable {
  user-select: none;
  position: relative;
  overflow-x: visible;
}

.resizer {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 100%;
  cursor: ew-resize;
}

.resizable * {
  max-width: 100% !important;
  box-sizing: border-box;
}


tbody tr.group-row td {
  position: relative;
}
tbody tr.group-row td::before {
  content: "";
  position: absolute;
  top: -0.9rem;
  left: -2.8rem;    /* geser ke kiri */
  right: -0.8rem;   /* geser ke kanan */
  height: 1.8rem;
  background: #FFFFFF;
}

.group-start td {
  background-color: #FFFFFF;   /* warna grup */
  border-top: 4px solid #F8F8F8 !important; /* garis pemisah antar grup */
}

.group-row td {
  background-color: #FFFFFF;   /* sama dengan group-start */
  border-top: none;            /* nyatu dengan row sebelumnya */
}

.group-start td:first-child {
  border-top-left-radius: 8px;
}
.group-start td:last-child {
  border-top-right-radius: 8px;
}
.group-row:last-child td:first-child {
  border-bottom-left-radius: 8px;
}
.group-row:last-child td:last-child {
  border-bottom-right-radius: 8px;
}

</style>
